<template>
  <v-progress-circular
    color="primary"
    indeterminate
    model-value="20"
  />
</template>

<script>
export default {
  name: 'CircularLoader',
};
</script>
